import { Button, Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import React from "react";
import { setAppLoader } from "../../actions/setAppLoader";
import { getUserData } from "../../actions/getUserData";
import { saveFormPath } from "../../services/userService";
import { getLoanStatus } from "../../services/avanseService";
import LoanProcessingStatus from "../utils/LoanProcessingStatus";
import LoanProcessingStatusOld from "../utils/LoanProcessingStatusOld";
export default function LoanApplicationProgress(props) {
  const alreadySubmitted = props.alreadySubmitted;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isFetching = useSelector((state) => state?.getUserData?.isFetching);
  const userData = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : null;
  const userId = userData?.userId;
  let detailId = localStorage.getItem("detailId");
  const userDetails = useSelector((state) => state?.getUserData?.data);

  const [pollingCount, setPollingCount] = React.useState(0);
  const [completionPercentage, setCompletionPercentage] = React.useState(15);
  const [breStatus, setBreStatus] = React.useState("PENDING");
  const [loanProcessStatus, setLoanProcessStatus] = React.useState("PENDING");
  const [isPolling, setIsPolling] = React.useState(false);
  const pollingIntervalRef = React.useRef(null);

  //Fetch user data
  React.useEffect(() => {
    dispatch(getUserData(detailId));
  }, [dispatch, detailId]);

  //Fetch loan status once on mount
  React.useEffect(() => {
    const fetchLoanStatus = async () => {
      try {
        const response = await getLoanStatus(detailId);
        console.log("Initial getLoanStatus response:", response);
        setBreStatus(response?.breStatus?.toUpperCase() || "PENDING");
        setCompletionPercentage(response?.completionPercentage || 0);
        setLoanProcessStatus(
          response?.loanProcessStatus?.toUpperCase() || "PENDING"
        );
         dispatch(setAppLoader(false));
      } catch (error) {
        console.error("Error fetching initial loan status:", error);
      }
    };
    if (detailId) fetchLoanStatus();
  }, [detailId]);

  React.useEffect(() => {
    setIsPolling(userDetails?.lender === "avanse");
    console.log(
      "User Details in Loan Application Progress:",
      userDetails?.lender,
      userDetails?.lender === "avanse"
    );
  }, [userDetails]);

  //Show Loader
  React.useEffect(() => {
    dispatch(setAppLoader(isFetching));
  }, [dispatch, isFetching]);

  //Show Loader
  React.useEffect(() => {
    if (loanProcessStatus === "SUCCESS" && breStatus !== "REJECTED") {
      setIsPolling(false);
      saveFormPath("/loanApproved", detailId);
      navigate("/loanApproved", { state: { tabValue: 10, stepperCount: 6 } });
    } else if (
      loanProcessStatus === "REJECTED" ||
      loanProcessStatus === "DECLINED" || breStatus === "REJECTED"
    ) {
      setIsPolling(false);
      saveFormPath("/loanDeclined", detailId);
      navigate("/loanDeclined");
    }
  }, [loanProcessStatus, detailId, navigate]);

  //Poll getLoanStatus API every 10 seconds
  React.useEffect(() => {
    if (!isPolling || !userDetails?.detailId) return;

    const pollLoanStatus = async () => {
      try {
        const response = await getLoanStatus(detailId);
        setPollingCount((prev) => prev + 1);
        if (pollingCount >= 25) {
          setIsPolling(false);
          if (pollingIntervalRef.current) {
            clearInterval(pollingIntervalRef.current);
          }
        }
        setBreStatus(response?.breStatus?.toUpperCase() || "PENDING");
        console.log("Polling getLoanStatus response:", response);
        setCompletionPercentage(response?.completionPercentage || 0);
        setLoanProcessStatus(
          response?.loanProcessStatus?.toUpperCase() || "PENDING"
        );
      } catch (error) {
        console.error("Error polling loan status:", error);
        setPollingCount((prev) => prev + 1);
      }
    };

    pollingIntervalRef.current = setInterval(pollLoanStatus, 20000);

    return () => {
      if (pollingIntervalRef.current) {
        clearInterval(pollingIntervalRef.current);
      }
    };
  }, [isPolling, detailId, navigate]);

  async function onSubmitBankStatement(e) {
    e.preventDefault();
    saveFormPath("/loanApproved", detailId);
    navigate("/loanApproved", { state: { tabValue: 10, stepperCount: 6 } });
  }

  return (
    <form
      onSubmit={(e) => onSubmitBankStatement(e)}
      className="applicationFormContainer"
    >
      <LoanProcessingStatusOld
        alreadySubmitted={alreadySubmitted}
        showMessage={breStatus !== "APPROVED"}
      />

      {/* Polling Status UI Component */}
      <LoanProcessingStatus
        completionPercentage={completionPercentage}
        isPolling={breStatus === "APPROVED"}
      />

      <div
        style={{
          padding: "50px 0px 0px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        {/* <Button
                    type="submit"
                    sx={{ fontStyle: "Lato" }}
                    color="neutral"
                    variant="contained"
                    >
                    Confirm and Submit
                </Button> */}
      </div>
      <Grid sx={{ textAlign: "left" }}>
        <Typography
          color="textColorR"
          sx={{ fontWeight: "bold", fontFamily: "lato" }}
          align="left"
          variant="inputLabel"
        >
          *Terms and Conditions apply
        </Typography>
      </Grid>
    </form>
  );
}
